import ExtendableTable from '@/components/ExtendableTable';
import InlineEdit from '@/components/InlineEdit';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';

const TermsDefinitionsView = ({ document, setDocument }) => {
  const { mode } = useDetailMode(DETAIL_TYPE.DOCUMENT);

  const handleChange = (value) => {
    setDocument({ ...document, terms: value });
  };

  return (
    <div className="space-y-4">
      <ExtendableTable
        columns={[
          {
            className: 'w-2/5',
            label: 'Terms',
            name: 'term',
            renderField: ({ onChange, value }) => (
              <>
                {mode !== DETAIL_MODE.STATIC ? (
                  <InlineEdit
                    onChange={onChange}
                    placeholder="Enter Terms"
                    value={value}
                  />
                ) : (
                  value
                )}
              </>
            ),
          },
          {
            label: 'Definitions',
            name: 'definition',
            renderField: ({ onChange, value }) => (
              <>
                {mode !== DETAIL_MODE.STATIC ? (
                  <InlineEdit
                    onChange={onChange}
                    placeholder="Enter Definition"
                    value={value}
                  />
                ) : (
                  value
                )}
              </>
            ),
          },
        ]}
        onChange={handleChange}
        mode={mode}
        value={document['terms']}
      />
    </div>
  );
};

export default TermsDefinitionsView;
